(function () {
	const STYLE_ID = 'rivet-theme-override';
	const FONT_HEADING = 'Druk Text Wide';
	const FONT_BODY = 'Montserrat';
	const MIN_SIZE = 14;

	const fontUrlFromPage = () => {
		const holder = document.querySelector('[data-rivet-font-url]');
		if (holder && holder.getAttribute('data-rivet-font-url')) {
			return holder.getAttribute('data-rivet-font-url');
		}
		return '';
	};

	const overrideCss = (fontUrl) => {
		const face = fontUrl
			? `@font-face{font-family:'${FONT_HEADING}';src:url('${fontUrl}') format('woff2');font-weight:700;font-style:normal;font-display:swap;}`
			: '';

		return `
			@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');
			${face}
			:host,
			:host * {
				font-family: ${FONT_BODY}, sans-serif !important;
			}
			:host h1,
			:host h2,
			:host h3,
			:host h4,
			:host h5,
			:host h6,
			:host .whitespace-pre-wrap {
				font-family: '${FONT_HEADING}', sans-serif !important;
			}
		`;
	};

	const injectStyles = (shadow, fontUrl) => {
		let style = shadow.getElementById(STYLE_ID);
		if (!style) {
			style = document.createElement('style');
			style.id = STYLE_ID;
			shadow.appendChild(style);
		}
		const css = overrideCss(fontUrl);
		if (style.textContent !== css) {
			style.textContent = css;
		}
	};

	const bumpFontSizes = (shadow) => {
		shadow.querySelectorAll('*').forEach((el) => {
			if (el.style.getPropertyValue('font-size') === `${MIN_SIZE}px`) return;
			const size = parseFloat(window.getComputedStyle(el).fontSize);
			if (size && size < MIN_SIZE) {
				el.style.setProperty('font-size', `${MIN_SIZE}px`, 'important');
			}
		});
	};

	const themeShadow = (shadow, fontUrl) => {
		if (!shadow) return;
		injectStyles(shadow, fontUrl);
		bumpFontSizes(shadow);

		if (shadow._rivetThemeObserved) return;
		shadow._rivetThemeObserved = true;

		let timer;
		const observer = new MutationObserver(() => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				observer.disconnect();
				injectStyles(shadow, fontUrl);
				bumpFontSizes(shadow);
				observer.observe(shadow, { childList: true, subtree: true });
			}, 50);
		});
		observer.observe(shadow, { childList: true, subtree: true });
	};

	const shadowsIn = (root) => {
		const found = [];
		if (root.shadowRoot) found.push(root.shadowRoot);
		root.querySelectorAll('*').forEach((el) => {
			if (el.shadowRoot) found.push(el.shadowRoot);
		});
		return found;
	};

	const applyAll = () => {
		const fontUrl = fontUrlFromPage();
		document.querySelectorAll('[id^="rivet-inline-signup"]').forEach((wrap) => {
			shadowsIn(wrap).forEach((shadow) => themeShadow(shadow, fontUrl));
		});
	};

	const watch = () => {
		applyAll();

		const wraps = document.querySelectorAll('[id^="rivet-inline-signup"]');
		wraps.forEach((wrap) => {
			if (wrap._rivetHostObserved) return;
			wrap._rivetHostObserved = true;
			const observer = new MutationObserver(() => applyAll());
			observer.observe(wrap, { childList: true, subtree: true });
		});

		let attempts = 0;
		const poll = setInterval(() => {
			attempts += 1;
			applyAll();
			if (attempts > 80) clearInterval(poll);
		}, 100);
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', watch);
	} else {
		watch();
	}

	document.addEventListener('shopify:section:load', () => {
		setTimeout(watch, 50);
	});
})();
